<template>
  <!-- <div class="box-container ma-0 pa-0" :style="'height: ' + mainContainerHeight + 'px !important;'"> -->
  <div class="row-content">
    <data-grid ref="refGridClients" v-model="client" :type="datatype" :items="clients" :showPeriod="false" :hideFilters="true" :showExport="false">
      <template v-slot:top>
        <t-btn class="ma-1" v-if="datatype && datatype.add" @click="add()">
          <v-icon>mdi-plus</v-icon>
          <span v-if="!isOnMobile">{{ "Нов " + datatype.name }}</span>
        </t-btn>
        <t-btn class="ma-1" v-if="datatype && datatype.edit" :disabled="!client" @click="edit(client)">
          <v-icon>mdi-pencil</v-icon>
          <span v-if="!isOnMobile">{{ "Редактирай " + datatype.name }}</span>
        </t-btn>
      </template>
    </data-grid>
  </div>
  <div v-if="datatype && !datatype.isLoading" class="row-header" style="max-height: 30% !important">
    <data-grid
      style="height: 400px"
      ref="refGridТags"
      :items="tags"
      :type="typeTags"
      :hideFilters="true"
      :showPeriod="false"
      :showExport="false"
      :noDataMessage="client ? 'Клиента няма свързани автомобили и RFID карти' : 'Не е избран клиент'"
    ></data-grid>
  </div>
  <!-- </div> -->
</template>

<script>
import { ref } from "vue";
import DataGrid from "@/components/DataGrid.vue";
import DataManagerData from "@/data/DataManagerData";
import DataManager from "@/data/DataManager";
export default {
  components: {
    DataGrid,
  },
  data() {
    return {
      client: null,
      datatype: null,
      clients: [],
      tags: [],
      typeTags: DataManagerData.Tags,
    };
  },
  computed: {},
  methods: {
    async setMeta(meta, err) {
      this.datatype = meta.datatype;

      this.$refs.refGridClients.setMeta(meta, err);
      // this.clients = DataManager.getData(this.datatype);
      // this.datatype.isLoading = true;
      if (err.success && !err.message) {
        await DataManager.loadData(DataManagerData.Tags);
        this.refreshData();
      }
      this.datatype.isLoading = false;
    },
    refreshData() {
      var clientName = this.client ? this.client.invCompanyName : "Неизвестен";
      this.typeTags.headers.find((h) => h.value == "cevuser.invCompanyName").filtervalues = [clientName];

      if (this.$refs.refGridТags) this.$refs.refGridТags.refreshData();
      // if (this.client) {
      //   var tgs = DataManager.getData(DataManagerData.Tags);
      //   var tags = tgs.filter((t) => t.cevuser && t.cevuser.id == this.client.id);
      //   this.cars = tags.filter((t) => t.type == "VID");
      //   this.cards = tags.filter((t) => t.type == "CARD");
      // }
    },
    async add() {
      if (this.datatype.add) {
        var res = await this.datatype.add();
        if (res) {
          await DataManager.loadData(this.datatype);
          if (this.$refs.refGridClients) this.$refs.refGridClients.refreshData();
          this.refreshData();
        }
      }
    },
    async edit(item) {
      if (this.datatype.edit) {
        var res = await this.datatype.edit(item);
        await DataManager.loadData(this.datatype);
        if (res) {
          if (this.$refs.refGridClients) this.$refs.refGridClients.refreshData();
          this.refreshData();
        }
      }
    },
    resizeContainer() {
      // if (this.$refs.refGridClients) this.$refs.refGridClients.recalcGridHeight();
      // if (this.$refs.refGridТags) this.$refs.refGridТags.recalcGridHeight();
    },
  },
  mounted() {},
  setup() {
    const refGridClients = ref(null);
    const refGridТags = ref(null);
    return { refGridClients, refGridТags };
  },
  watch: {
    client: function () {
      this.refreshData();
      // console.log(newVal);
    },
  },
};
</script>

<style>
</style>